import React, { useEffect, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import closeIcon from "../../assets/icons/close.svg";
import searchIcon from "../../assets/icons/search.svg";
import tuneIcon from "../../assets/icons/tune.svg";
import { useNavigate } from "react-router-dom";
import {
  get_community_brand_select,
  get_portfolio_select,
  get_product_type_select,
} from "../../Axios";
import Pagination from "../Utility/Pagination";
import PortfolioBoard from "./PortfolioBoard";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { useDispatch } from "react-redux";
import {
  reduxChangeCommunitySelectBrandNumber,
  reduxChangeCommunitySelectPage,
  reduxChangeCommunitySelectProductTypeNumber,
  reduxChangeCommunitySelectSearchText,
  reduxChangeCommunitySelectSortNumber
} from "../../redux/CommunitySlice";
import { varSpace } from "../../Variable";
// import star_blk from "../../assets/icons/star_blk.svg";

interface PortfolioList {
  ablack_comunity_ID: number;
  ablack_comunity_brand_ID: number;
  ablack_comunity_division_name: string;
  product_kor_name: string;
  color_name: string;
  ablack_comunity_thumbnail_img: string;
  brand_kor_name: string;
  product_eng_name: string;
  brand_eng_name: string;
  ablack_comunity_status: number;
};

interface BrandList {
  brand_ID: number;
  brand_kor_name: string;
  brand_img: string;
};

interface ProductTypeList {
  product_type_ID: number;
  product_type_kor_name: string;
};

interface PlaceList {
  value: string;
  label: string;
}

const Community: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const searchText = useSelector((state: RootState) => state.communityData.community_select_search_text);
  const [sortButton, setSortButton] = useState<boolean>(false);
  const [placeButton, setPlaceButton] = useState<boolean>(false);
  const [squareMeterButton, setSquareMeterButton] = useState<boolean>(false);

  const [portfolioList, setPortfolioList] = useState<PortfolioList[]>([]);
  const [sortList, setSortList] = useState<string[]>(["최신순", "인기순"]);
  const sortNumber = useSelector((state: RootState) => state.communityData.community_select_sort_number);
  const [brandList, setBrandList] = useState<BrandList[]>([]);
  const [productTypeList, setProductTypeList] = useState<ProductTypeList[]>([]);
  const [placeList, setPlaceList] = useState<PlaceList[]>([]);
  const [placeNumber, setPlaceNumber] = useState<string>('');
  const [includingPlaceUnregistered, setIncludingPlaceUnregistered] = useState<boolean>(true);
  const [includingSquareMeterUnregistered, setIncludingSquareMeterUnregistered] = useState<boolean>(true);
  const [applySquareMeterQuery, setApplySquareMeterQuery] = useState({
    min_value: 0,
    max_value: 11,
    including_square_meter_unregistered: true,
  });

  const brandNumber = useSelector((state: RootState) => state.communityData.community_select_brand_number);
  const productTypeNumber = useSelector((state: RootState) => state.communityData.community_select_product_type_number);
  const page = useSelector((state: RootState) => state.communityData.community_select_page);
  const [totalPortfolio, setTotalPortfolio] = useState<number>(0);
  const [queryText, setQueryText] = useState<string>("");

  const fixedMinSquareMeter = 0;
  const fixedMaxSquareMeter = 11;
  const [squareMeterMinValue, setSquareMeterMinValue] = useState(fixedMinSquareMeter); 
  const [squareMeterMaxValue, setSquareMeterMaxValue] = useState(fixedMaxSquareMeter);
  const [rangeMinPercent, setRangeMinPercent] = useState(0);
  const [rangeMaxPercent, setRangeMaxPercent] = useState(0);
  const squareMeterGap = 1;

  useEffect(() => {
    get_community_brand_select().then(result => {
      setBrandList(result);
    });
    get_product_type_select().then(result => {
      setProductTypeList(result);
    });
    let list = [...varSpace];
    let obj = {
      value: "",
      label: "전체",
    };
    list.unshift(obj);
    setPlaceList(list);
  }, []);

  useEffect(() => {
    handleSelectPortfolio();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    brandNumber,
    productTypeNumber,
    page,
    queryText,
    sortNumber,
    placeNumber,
    includingPlaceUnregistered,
    applySquareMeterQuery,
  ]);

  const handleSelectPortfolio = () => {
    get_portfolio_select(
      brandNumber,
      productTypeNumber,
      page,
      queryText,
      sortNumber,
      placeNumber,
      includingPlaceUnregistered,
      applySquareMeterQuery
    ).then(result => {
      setPortfolioList(result.rows);
      setTotalPortfolio(result.total_count);
    });
  };

  const handlePage = (page: number) => {
    dispatch(reduxChangeCommunitySelectPage(page));
  };

  const handleSortCommunityList = (index: number) => {
    let list = [...sortList];
    [list[0], list[index]] = [list[index], list[0]];
    setSortList(list);
    let num = 0;
    switch (list[0]) {
      case '최신순': num = 0; break;
      case '인기순': num = 1; break;
      default: num = 0;
    };
    dispatch(reduxChangeCommunitySelectSortNumber(num));
  };

  useEffect(() => {
    handleSortCommunityList(sortNumber);
    setQueryText(searchText);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const prciesquareMeterMinValueHandler = (e: any) => {
    setSquareMeterMinValue(Number(e.target.value));
  };
  
  const prciesquareMeterMaxValueHandler = (e: any) => {
    setSquareMeterMaxValue(Number(e.target.value));
  };
  
  useEffect(() => {
    if (squareMeterMaxValue - squareMeterMinValue < squareMeterGap) {
      setSquareMeterMaxValue(squareMeterMinValue => squareMeterMinValue + squareMeterGap);
      setSquareMeterMinValue(squareMeterMaxValue => squareMeterMaxValue - squareMeterGap);
    } else {
      setRangeMinPercent(() => (squareMeterMinValue / fixedMaxSquareMeter) * 100);
      setRangeMaxPercent(() => 100 - (squareMeterMaxValue / fixedMaxSquareMeter) * 100);
    }
  }, [squareMeterMaxValue, squareMeterMinValue]);

  return (
    <S.SectionContainer>
      <S.SectionWidth $width={1080}>
        <S.SectionTitleBox>
          <h1>포트폴리오</h1>
          <h3>다양한 시공 후기를 확인하실 수 있습니다.</h3>
        </S.SectionTitleBox>

        <S.SectionContent style={{ marginTop: "50px" }}>
          <div></div>
          <S.SearchBox>
            <input
              style={{ width: "550px" }}
              type="text" placeholder="브랜드, 제품명 검색"
              value={searchText}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                dispatch(reduxChangeCommunitySelectSearchText(e.target.value.toLowerCase()));
              }}
              onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                const key = e.code;
                switch (key) {
                  case 'Enter': setQueryText(searchText); break;
                };
                dispatch(reduxChangeCommunitySelectPage(1));
              }}
            />

            {searchText &&
              <img className="close-icon" src={closeIcon} alt="" onClick={() => {
                dispatch(reduxChangeCommunitySelectSearchText(""));
                setQueryText("");
                dispatch(reduxChangeCommunitySelectPage(1));
              }} />
            }

            <img
              className="search-icon cursor-pointer"
              src={searchIcon} alt=""
              onClick={() => {
                setQueryText(searchText);
                dispatch(reduxChangeCommunitySelectPage(1));
              }}
            />
          </S.SearchBox>
          <div></div>
        </S.SectionContent>

        <S.SectionContent style={{ width: "100%", marginBottom: "17px", marginTop: "30px" }}>
          <div className="community-filter-button-box relative">
            <S.communitySortButton
              className={`w-[97px] ${sortButton && "shadow-2xl z-10"}`}
              onClick={() => {
                setSortButton(!sortButton);
              }}
            >
              <div className="appear-area">
                <img src={tuneIcon} alt="" />
                <span className="ml-[10px]">{sortList[0]}</span>
              </div>
              {sortButton &&
                <>
                  <hr />
                  <div className="py-2">
                    <div className="dis-appear-area" onClick={() => handleSortCommunityList(0)}>
                      <span>{sortList[0]}</span>
                    </div>
                    <div className="dis-appear-area" onClick={() => handleSortCommunityList(1)}>
                      <span>{sortList[1]}</span>
                    </div>
                  </div>
                </>
              }
            </S.communitySortButton>
            <S.communitySortButton
              className={`w-[150px] left-28 ${placeButton && "shadow-2xl z-10"}`}
            >
              <div
                className="appear-area" 
              >
                <img
                  src={tuneIcon} alt=""
                  onClick={(e) => {
                    if (e.target === e.currentTarget) {
                      setPlaceButton(!placeButton);
                    }
                  }}
                />
                <span
                  className="pl-[10px] w-[100%] text-right"
                  onClick={(e) => {
                    if (e.target === e.currentTarget) {
                      setPlaceButton(!placeButton);
                    }
                  }}
                >
                  {placeNumber === '' ? "설치장소 : 전체" : placeList[Number(placeNumber)].label}
                </span>
              </div>
              {placeButton && (
                <>
                  <hr />
                  <S.CommunityDropdownBox>
                    {placeList.map((tmp, idx) =>
                      <div
                        key={idx}
                        className="dis-appear-area pl-4"
                        onClick={() => {
                          setPlaceButton(false);
                          setPlaceNumber(tmp.value);
                        }}
                      >
                        <span>{tmp.label}</span>
                      </div>
                    )}
                    <div
                      className="dis-appear-area checkbox-undefined pl-4"
                      onClick={() => {
                        setIncludingPlaceUnregistered(!includingPlaceUnregistered);
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={includingPlaceUnregistered ? true : false}
                        readOnly
                      />
                      <label>미등록 포함</label>
                    </div>
                  </S.CommunityDropdownBox>
                </>
              )}
            </S.communitySortButton>
            <S.communitySortButton
              className={`w-[210px] left-[276px] ${squareMeterButton && "shadow-2xl z-10"}`}
              style={{cursor: "default"}}
            >
              <div
                className="appear-area cursor-pointer"
                style={{justifyContent: "start"}}
                onClick={() => setSquareMeterButton(!squareMeterButton)}
              >
                <img src={tuneIcon} alt="" />
                <span className="mx-[10px]">전체 평수</span>
                <div className="text-[12px]">
                  {squareMeterMinValue !== fixedMinSquareMeter && (
                    <span>{squareMeterMinValue * 10}평 이상</span>
                  )}
                  {(squareMeterMinValue === fixedMinSquareMeter && squareMeterMaxValue === fixedMaxSquareMeter) && (
                    <span>전체</span>
                  )}
                  {(squareMeterMinValue !== fixedMinSquareMeter && squareMeterMaxValue !== fixedMaxSquareMeter) && (
                    <span>&nbsp;~&nbsp;</span>
                  )}
                  {squareMeterMaxValue !== fixedMaxSquareMeter && (
                    <span>{squareMeterMaxValue * 10}평 미만</span>
                  )}
                </div>
              </div>
              {squareMeterButton && (
                <>
                  <hr />
                  <div className="py-4">
                    <S.FilterSquareMeterSlide>
                      <S.FilterSquareMeterSlideInner
                        $rangeMinPercent={rangeMinPercent}
                        $rangeMaxPercent={rangeMaxPercent}
                      />
                      <S.FilterSquareMeterRangeWrap>
                        <S.FilterSquareMeterRangeMin
                          type="range"
                          min={fixedMinSquareMeter}
                          max={fixedMaxSquareMeter - squareMeterGap}
                          step={1}
                          value={squareMeterMinValue}
                          onChange={(e) => {
                            prciesquareMeterMinValueHandler(e);
                          }}
                        />
                        <S.FilterSquareMeterRangeMax
                          type="range"
                          min={fixedMinSquareMeter + squareMeterGap}
                          max={fixedMaxSquareMeter}
                          step={1}
                          value={squareMeterMaxValue}
                          onChange={(e) => {
                            prciesquareMeterMaxValueHandler(e);
                          }}
                        />
                      </S.FilterSquareMeterRangeWrap>
                    </S.FilterSquareMeterSlide>
                  </div>
                  <S.SquareMeterIndicator>
                    <div>
                      {squareMeterMinValue !== fixedMinSquareMeter && (
                        <span>{squareMeterMinValue * 10}평 이상</span>
                      )}
                      {(squareMeterMinValue === fixedMinSquareMeter && squareMeterMaxValue === fixedMaxSquareMeter) && (
                        <span>전체</span>
                      )}
                      {(squareMeterMinValue !== fixedMinSquareMeter && squareMeterMaxValue !== fixedMaxSquareMeter) && (
                        <span>&nbsp;~&nbsp;</span>
                      )}
                      {squareMeterMaxValue !== fixedMaxSquareMeter && (
                        <span>{squareMeterMaxValue * 10}평 미만</span>
                      )}
                    </div>
                    <div
                      className="dis-appear-area checkbox-undefined pl-4"
                      onClick={() => {
                        setIncludingSquareMeterUnregistered(!includingSquareMeterUnregistered);
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={includingSquareMeterUnregistered ? true : false}
                        readOnly
                      />
                      <label>미등록 포함</label>
                    </div>
                    <div
                      className="apply-button"
                      onClick={() => {
                        setSquareMeterButton(false);
                        let square_meter = {...applySquareMeterQuery}
                        square_meter.min_value = squareMeterMinValue+1;
                        square_meter.max_value = squareMeterMaxValue;
                        square_meter.including_square_meter_unregistered = includingSquareMeterUnregistered;
                        setApplySquareMeterQuery(square_meter);
                      }}
                    >
                      <hr />
                      <span>적용</span>
                    </div>
                  </S.SquareMeterIndicator>
                </>
              )}
            </S.communitySortButton>
          </div>
          <div className="community-filter-button-box">
            <button className="w-[92px]" onClick={() => navigate('/post_portfolio')}>글쓰기</button>
          </div>
        </S.SectionContent>

        <div className="border-b-[0.5px] border-solid border-middleGray02"></div>
        <S.CommunityCategoryBox>
          <S.CommunityBrandButton
            $btnSelect={brandNumber === 0 ? true : false}
            onClick={() => {
              dispatch(reduxChangeCommunitySelectBrandNumber(0));
              dispatch(reduxChangeCommunitySelectPage(1));
            }}
          >
            전체
          </S.CommunityBrandButton>

          {brandList.map((tmp, idx) =>
            <S.CommunityBrandButton
              key={idx}
              $btnSelect={brandNumber === tmp.brand_ID ? true : false}
              onClick={() => {
                dispatch(reduxChangeCommunitySelectBrandNumber(tmp.brand_ID));
                dispatch(reduxChangeCommunitySelectPage(1));
              }}
            >
              {tmp.brand_kor_name}
            </S.CommunityBrandButton>
          )}
        </S.CommunityCategoryBox>
        <div className="border-b-[0.5px] border-solid border-middleGray02"></div>

        <S.CommunityCategoryBox>
          <S.CommunityBrandButton
            $btnSelect={productTypeNumber === 0 ? true : false}
            onClick={() => {
                dispatch(reduxChangeCommunitySelectProductTypeNumber(0));
                dispatch(reduxChangeCommunitySelectPage(1));
              }}
          >
            전체
          </S.CommunityBrandButton>

          {productTypeList.map((tmp, idx) =>
            <S.CommunityBrandButton
              key={idx}
              $btnSelect={productTypeNumber === tmp.product_type_ID ? true : false}
              onClick={() => {
                dispatch(reduxChangeCommunitySelectProductTypeNumber(tmp.product_type_ID));
                dispatch(reduxChangeCommunitySelectPage(1));
              }}
            >
              {tmp.product_type_kor_name}
            </S.CommunityBrandButton>
          )}
        </S.CommunityCategoryBox>
        <div className="border-b-[0.5px] border-solid border-middleGray02"></div>

        {portfolioList.length < 1 &&
          <S.EmptyContentBox>
            <p>해당 조건과 일치하는 결과가 없습니다.</p>
          </S.EmptyContentBox>
        }

        <PortfolioBoard portfolioList={portfolioList} handleSelectFavoritePortfolio={() => { }} handleFavoritePortfolioBrand={() => { }} />

        <br />
        <br />
        <Pagination totalCount={totalPortfolio} handlePage={handlePage} listCount={15} page={page} />

        <br />
        <br />
        <br />
      </S.SectionWidth>
      {(sortButton || squareMeterButton || placeButton) && (
        <S.PortfolioDropdownBackground
          onClick={() => {
            setSortButton(false);
            setPlaceButton(false);
            setSquareMeterButton(false);
          }}
        />
      )}
    </S.SectionContainer>
  )
};

export default Community;